import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '@app/components/components.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { LottieModule } from 'ngx-lottie';

import { BoardingVideoComponent } from './boarding-video/boarding-video.component';
import { CompletedComponent } from './completed/completed.component';
import { SecondStepComponent } from './second-step/second-step.component';
import { ThirdStepComponent } from './third-step/third-step.component';
import { WelcomeComponent } from './welcome/welcome.component';

const components = [
  SecondStepComponent,
  ThirdStepComponent,
  WelcomeComponent,
  CompletedComponent,
  BoardingVideoComponent
];

@NgModule({
  declarations: components,
  imports: [CommonModule, TranslateModule.forChild(), LottieModule, ComponentsModule, PipesModule],
  exports: components
})
export class OnBoardingStepperModule {}
